import emptyCadastroBase from '../../para/empty/emptyCadastroBase'

export default {
  ...emptyCadastroBase,
  tipo: {
    codigo: ''
  },
  json: {
    numeroProcesso: null,
    tipo: '',
    dataCadastro: '',
    dataAtualizacao: '',
    situacao: '',
    hash: '',
    isAceiteTermoDeCompromisso: false,
    qualificacao: {
      area: null,
      cargoPublico: '',
      exploracaoAgricola: '',
      ocupaImovel: '',
      possuiImovelRuralTitulado: '',
      renda: '',
      tipoArea: '',
      municipio: {
        nome: '',
        estadoCod: '',
        id: null
      },
      moduloFiscal: 0
    },
    cadastrante: {
      pessoa: {
        cadastranteInterno: false,
        isPessoaFisica: '',
        endereco: {
          logradouro: '',
          numero: '',
          complemento: '',
          bairro: '',
          cep: '',
          idMunicipio: '',
          semNumero: '',
          municipio: {
            nome: '',
            estadoCod: '',
            id: ''
          }
        },
        pessoaFisica: {
          cpf: '',
          nome: ''
        },
        pessoaJuridica: {
          cnpj: '',
          razaoSocial: '',
          cpf: '',
          nome: ''
        }
      }
    },
    interessado: {
      conjuge: {
        tipo: 'PF',
        pessoaFisica: {
          cpf: '',
          nome: '',
          apelido: '',
          tipoDocumento: '',
          outrosTipoDocumento: '',
          rg: '',
          nacionalidade: '',
          temCertidaoObito: '',
          orgaoExpedidor: {
            codigo: null,
            nome: null,
            estado: null
          },
          ufNaturalidade: '',
          dataNascimento: '',
          naturalidade: ''
        }
      },
      pessoa: {
        cadastranteInterno: false,
        email: '',
        telefones: [],
        isPessoaFisica: '',
        pessoaFisica: {
          cpf: '',
          nome: '',
          apelido: '',
          tipoDocumento: '',
          outrosTipoDocumento: '',
          rg: '',
          nacionalidade: '',
          estadoCivil: '',
          descEstadoCivil: '',
          orgaoExpedidor: {
            codigo: null,
            nome: null,
            estado: null
          },
          dataNascimento: '',
          ufNaturalidade: '',
          naturalidade: ''
        },
        endereco: {
          logradouro: '',
          numero: '',
          complemento: '',
          bairro: '',
          cep: '',
          idMunicipio: '',
          semNumero: '',
          municipio: {
            nome: '',
            estadoCod: '',
            id: ''
          }
        },
        pessoaJuridica: {
          cnpj: '',
          razaoSocial: '',
          presidenteAssociacao: {
            cpf: '',
            nome: '',
            tipoDocumento: '',
            outrosTipoDocumento: '',
            rg: '',
            nomeOrgaoExpedidor: '',
            orgaoExpedidor: {
              codigo: null,
              nome: null,
              estado: null
            }
          }
        }
      },
      sociosRepresentantesLegaisLista: [],
      documentos: []
    },
    imovel: {
      possuiCar: '',
      numeroReciboCar: '',
      possuiImovel: '',
      nome: '',
      area: '',
      tipoArea: '',
      descricaoAcesso: '',
      tempoOcupacao: null,
      idMunicipio: '',
      idGleba: null,
      municipioGleba: null,
      municipio: null,
      ocupantesAnteriores: '',
      conflitos: '',
      documentos: [],
      // matricula
      cnsMatricula: null,
      // numeroMatricula: null,
      // livroMatricula: null,
      // numeroFolhaMatricula: null,
      // dados do titulo
      nomeBeneficiarioTitulo: null,
      dataRegistro: null,
      // nomeCartorio: null,
      ufLocalizacaoSede: 'MA',
      // municipioCartorio: null,
      localizacao: '',
      latitude: '',
      longitude: '',
      logradouro: '',
      numero: '',
      semNumero: false
    }
  }
}



// WEBPACK FOOTER //
// ./src/screens/central/cadastros/maranhao/empty/emptyProcessoFisico.js